export default __webpack_public_path__ + "locales/es/DeleteThirdPartyDialog.json?hash=71f5fb024c29d622ae4b527261753c1a";